import { Tooltip } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { ColorFieldProps } from "./types";
import { DEFAULT_EMPTY_COLOR } from "./constants";
import {
  FieldRow,
  Swatch,
  SwatchEmpty,
  FieldMeta,
  FieldLabel,
  FieldDescription,
  FieldRight,
  HexBadge,
  DefaultBadge,
  ClearBtn,
} from "./styles";

function ColorField({ fieldKey, label, description, value, onChange, onClear }: ColorFieldProps) {
  const isSet = value !== null;

  return (
    <FieldRow>
      <Tooltip title={isSet ? `Click to change ${label}` : `Click to set ${label}`}>
        <Swatch $color={value} $isSet={isSet} htmlFor={`color-${fieldKey}`}>
          {!isSet && <SwatchEmpty>+</SwatchEmpty>}
          <input
            id={`color-${fieldKey}`}
            type="color"
            value={isSet ? value : DEFAULT_EMPTY_COLOR}
            onChange={(e) => onChange(fieldKey, e.target.value)}
          />
        </Swatch>
      </Tooltip>

      <FieldMeta>
        <FieldLabel>{label}</FieldLabel>
        <FieldDescription title={description}>{description}</FieldDescription>
      </FieldMeta>

      <FieldRight>
        {isSet ? (
          <>
            <HexBadge>{value}</HexBadge>
            <Tooltip title="Reset to kiosk default">
              <ClearBtn onClick={() => onClear(fieldKey)}>
                <CloseCircleOutlined />
              </ClearBtn>
            </Tooltip>
          </>
        ) : (
          <DefaultBadge>Default</DefaultBadge>
        )}
      </FieldRight>
    </FieldRow>
  );
}

export default ColorField;
